import React, {useContext, useEffect, useState} from "react";


import "../../style/newsFeedCard.css";
import {Link} from "react-router-dom";
import {azureTokenContext, userIdContext} from "../../App";
import * as ApiCalls from "./ApiCalls.js";
import Loading from "./Loading";
import {NewsItem} from "../../Types/NewsItem";
import {stripHtmlAndGetFirstWords} from "../../utils/htmlUtils";

export default function NewsFeedCard() {

    const azureToken = useContext(azureTokenContext);
    const userId = useContext(userIdContext);
    const [news, setNews] = useState<NewsItem[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        ApiCalls.getPublishedNews(azureToken)
            .then((res) => {
                setNews(res);
            })
            .catch(async (err) => {
                    console.error("Get published news failed.", err);
                    await log("ERROR", "Failed getPublishedNews " + err.message, "AuthorPortal", "", "");
                }
            )
            .finally(() => {
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [azureToken]);


    const log = async (level, message, method, workItemId, userRole) => {
        await ApiCalls.log(level, message, method, workItemId, userRole, userId, azureToken);
    };

    return (
        <div className="right-side-cards-container news-feed-card">
            <h3 className="news-feed-title">Nyheter</h3>
            <div className="news-feed-item-container">
                {loading && (
                    <div style={{
                        minWidth: "4rem",
                        minHeight: "4rem",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <Loading/>
                    </div>
                )}
                {!loading && news.length === 0 && (<div className="news-feed-item">Ingen nyheter tilgjengelig</div>)}
                {!loading && news.length > 0 && (<div className="news-feed-item-separator">
                        <Link to="/newsfeed" className="news-feed-item">
                            <strong>{news[0].Title}</strong>
                            <p className="news-feed-first-words">{stripHtmlAndGetFirstWords(news[0].Content, 12)}</p>
                        </Link>
                    </div>
                )}
                {!loading && news.length > 1 && (<Link to={"/newsfeed"} className="news-feed-more-link">
                        <div className="news-feed-more">Alle nyheter</div>
                    </Link>
                )}


            </div>
        </div>
    );
}
